/**
 * VIO often returns voucher/token images as relative paths (e.g. /uploads/...).
 * The marketing PWA runs on another origin, so those URLs must be prefixed with the VIO host.
 *
 * Base resolution (same idea as miniapp-claim-v2 ops `vioAssetUrl.js`):
 *   1) `serverBase` from GET /marketing-pages/:id → `vioAssetBaseUrl` (from backend env)
 *   2) REACT_APP_VIO_PUBLIC_URL
 *   3) Origin of REACT_APP_VIO_EXTERNAL_API_URL
 */

function trimBase(b) {
  return (b || '').trim().replace(/\/$/, '');
}

function pickResolveBaseFromEnv() {
  const pub = trimBase(process.env.REACT_APP_VIO_PUBLIC_URL);
  if (pub) return pub;
  const ext = (process.env.REACT_APP_VIO_EXTERNAL_API_URL || '').trim();
  if (!ext) return '';
  try {
    return new URL(ext).origin;
  } catch {
    return '';
  }
}

/**
 * @param {string|null|undefined} raw
 * @param {string|null|undefined} serverBase - from page JSON `vioAssetBaseUrl` (preferred)
 * @returns {string|null}
 */
export function resolveVioAssetUrl(raw, serverBase) {
  if (raw == null) return null;
  const s = typeof raw === 'string' ? raw.trim() : '';
  if (!s) return null;
  if (/^https?:\/\//i.test(s)) return s;
  if (/^data:/i.test(s)) return s;
  // CRA public assets — same origin as the PWA
  if (/^\/(images|static)\b/i.test(s)) return s;

  const base = trimBase(serverBase) || pickResolveBaseFromEnv();
  if (!base) return null;

  try {
    const path = s.startsWith('/') ? s : `/${s.replace(/^\/+/, '')}`;
    return new URL(path, `${base}/`).href;
  } catch {
    const cleanPath = s.replace(/^\//, '');
    return `${base}/${cleanPath}`;
  }
}
